import axios from 'axios';
import axiosInstance from 'utils/axiosInstance';
import {usersUrls} from 'helpers/Urls';

const sendLoginCode = async ({phone}) => {
  return await axios.post(usersUrls.sendLoginCode, {phone, role: ''});
};

const loginApi = async ({activationCodeId, code}) => {
  return await axios.post(usersUrls.login, {activationCodeId, code});
};

const signup = async ({
  firstName,
  lastName,
  isScanCenter,
  scanCenterName,
  scanCenterAddress,
  cityId,
  isAgent,
}) => {
  return await axiosInstance.post(usersUrls.register, {
    firstName,
    lastName,
    isScanCenter,
    scanCenterName,
    scanCenterAddress,
    cityId,
    isAgent,
  });
};

export {loginApi, sendLoginCode, signup};
